import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { EmailFeedService } from 'src/app/services/integrations/email/email-feed.service';
import ClientProcessor from './email-feeds/client-processor';
import { EmailService } from 'src/app/services/integrations/email/email.service';
import FileSaver from 'file-saver';
import * as de from 'src/assets/calendar-assets/core/locales/de';
import { NoteService } from 'src/app/services/notes/note.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as $ from 'jquery';
import { GeneralService } from 'src/app/services/general.service';
import { AllFeedsComponent } from './all-feeds/all-feeds.component';
import { LogActivityService } from 'src/app/services/settings-services/log-activity.service';

@Component({
  selector: 'app-feeds',
  templateUrl: './feeds.component.html',
  styleUrls: ['./feeds.component.css']
})
export class FeedsComponent implements OnInit, OnDestroy {
  @ViewChild(AllFeedsComponent) feeds: AllFeedsComponent
  private unsubscribe = new Subject<any>();
  clientsProcessor = ClientProcessor;
  selectedMail: any;
  mailAttachments: Array<any>;
  note: any = {};
  selectedActivityID: string = '';
  editedOrgAct: any = {};
  activityType: any = [];
  showLoading: boolean = false;
  showNoteLoading: boolean = false;
  showEditLoading: boolean = false;
  pageContext
  editNoteForm = new FormGroup({
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    noteID: new FormControl(''),
    assigneeID: new FormControl(''),
    clientID: new FormControl(''),
    clientName: new FormControl(''),
    creatorName: new FormControl(''),
    dealCode: new FormControl(''),
    dealName: new FormControl(''),
    teamID: new FormControl(''),
    otherName: new FormControl(''),
    otherID: new FormControl(''),
    createdDate: new FormControl(''),
  })

  editActivityForm = this.formBuilder.group({
    content: new FormControl('', [Validators.required, noWhitespaceValidator]),
    type: new FormControl('', Validators.required),
    id: new FormControl(''),
    assigneeID: new FormControl(''),
    clientID: new FormControl(''),
    clientName: new FormControl(''),
    createdDate: new FormControl(''),
    creatorName: new FormControl(''),
    dateLogged: new FormControl(''),
    dealCode: new FormControl(''),
    dealName: new FormControl(''),
    duration: new FormControl(''),
    otherName: new FormControl(''),
    otherID: new FormControl(''),
    teamID: new FormControl(''),
  });

  constructor(
    private formBuilder: FormBuilder,
    private emailFeedService: EmailFeedService,
    private emailService: EmailService,
    private noteSrv: NoteService,
    private logSrv: LogActivityService,
    private generalSrv: GeneralService,
  ) { }

  ngOnInit() {

    this.fetchLogActivityTypes();

    this.emailService.email_context.subscribe((context: any) => {
      if (!this.generalSrv.checkIfObjectIsEmpty(context)) {
        this.pageContext = context.name;
      }
    });

    this.emailService.emailToActOn.subscribe((mail: any) => {
      if (Object.keys(mail).length) {
        let dealName = '', dealCode = '';
        if (mail.thread && mail.thread.deal) {
          dealName = mail.thread.deal.name || '';
          dealCode = mail.thread.deal.id || '';
        }
        this.selectedMail = { ...mail, dealCode, dealName };
        if (this.selectedMail.service === 'mailgun') {
          const receiver = this.selectedMail.headers.To;
          let extractMail;
          if (receiver.indexOf('<') > -1) {
            extractMail = this.selectedMail.headers.To.split('<')[1];
            extractMail = extractMail.substr(0, extractMail.length - 1);
          } else {
            extractMail = receiver;
          }

          this.selectedMail = {
            ...this.selectedMail,
            content: this.selectedMail.body,
            recipient: extractMail
          }
        }
       
      }
    })

    this.emailFeedService.mailAttachments.subscribe((attachments: any[]) => {
      if (attachments.length) {
        let attachmentMap = attachments.reduce((atts, attachment) => {
          return {
            ...atts,
            [attachment.name]: attachment,
          };
        }, {});

        this.mailAttachments = Object.keys(attachmentMap).map(key => ({ ...attachmentMap[key] }));
      }
    })

    this.noteSrv.noteItem.subscribe(data => {
      if (!data) return
      if (data) {
        this.onViewSingleNote(data);
      }
    })

    this.logSrv.logItem.subscribe(data => {
      if (!data) return;
      if (data) {
        this.onViewSingleActivity(data);
      }
    })
    this.logSrv.refreshNeeded$.subscribe(() => {
      this.feeds.getPageContext();
    })

    this.noteSrv.refreshNeeded$.subscribe(() => {
      this.feeds.getPageContext();
    })
  }

  closeEmailView() {
    const emailViewModal = document.getElementById('viewEmailModal');
    emailViewModal.style.display = "none";
    this.selectedMail = {};
    this.mailAttachments = [];
    this.emailFeedService.mailAttachments.next([]);
    this.emailService.emailToActOn.next({});
  }

  downloadAttachment(name: string) {
    this.emailService.downloadAttachment(name).subscribe((response: any) => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, name);
    })
  }

  replyMail(message) {
    this.emailService.emailToActOn.next({ ...message, type: 'reply' });
  }

  /**
   * NOTES
   */

  /**
   * Edit notes by ID
   * @param id
   */
  onEditNote(note) {
    this.editUserNote(note);
  }

  /**
  * View note By ID
  * @param id
  */
  onViewSingleNote(id) {
    this.note = {};
    this.showNoteLoading = true;
    this.viewSingleNote(id);
  }

  /**
   * View note By ID
   * @param id
   */
  private viewSingleNote(id) {
    this.editNoteForm.patchValue({ content: '' });
    this.noteSrv.fetchNoteByID(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((note) => {
        this.showNoteLoading = false;
        this.showLoading = false;
        this.note = note;
        this.editNoteForm.patchValue({ content: this.note.content });
      });
  }

  /**
   * Edit notes by ID
   * @param id
   */
  private editUserNote(note) {
    this.showLoading = true;
    this.editNoteForm.patchValue({
      noteID: note.id,
      assigneeID: note.assigneeID,
      clientID: note.clientID,
      clientName: note.clientName,
      creatorName: note.creatorName,
      dealCode: note.dealCode,
      dealName: note.dealName,
      teamID: note.teamID,
      otherName: note.otherName,
      otherID: note.otherID,
      createdDate: note.createdDate,
    });
    if (this.editNoteForm.valid) {
      this.noteSrv.editNote(this.editNoteForm.getRawValue()).subscribe(() => {
        this.showLoading = false;
        $("#closeNoteModal2").click();
        this.generalSrv.sweetAlertFileUpdateSuccessWithoutNav('Note');
        this.feeds.getPageContext();
      }, (error) => {
        this.showLoading = false;
        $("#closeNoteModal2").click();
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      })
    }
  }

  /**
  * LOGES
  */

  /**
 * View Activity Log
 * @param id
 */
  onViewSingleActivity(id) {
    this.editedOrgAct = {};
    this.showLoading = true;
    this.selectedActivityID = id;
    this.viewSingleActivity(id);
  }

  /**
  * Edit Activity Log
  */
  onEditActivity(editedOrgAct) {
    this.editActivityForm.patchValue({
      id: this.selectedActivityID,
      assigneeID: editedOrgAct.assigneeID,
      clientID: editedOrgAct.clientID,
      clientName: editedOrgAct.clientName,
      createdDate: editedOrgAct.createdDate,
      creatorName: editedOrgAct.creatorName,
      dateLogged: editedOrgAct.dateLogged,
      dealCode: editedOrgAct.dealCode,
      dealName: editedOrgAct.dealName,
      duration: editedOrgAct.duration,
      otherName: editedOrgAct.otherName,
      otherID: editedOrgAct.otherID,
      teamID: editedOrgAct.teamID,
    });
    this.editActivity();
  }

  get f() { return this.editActivityForm.controls; }

  /**
   * View Activity Log
   * @param id
   */
  private viewSingleActivity(id) {
    this.logSrv.getSingleActivityLog(id)
      .subscribe((editedOrgAct) => {
        this.showLoading = false;
        this.editedOrgAct = editedOrgAct;
        this.f.content.setValue(this.editedOrgAct.content);
        this.f.type.setValue(this.editedOrgAct.type);
        this.f.id.setValue(this.editedOrgAct.id);
      });
  }

  /**
   * Edit Activity Log
   */
  private editActivity() {
    this.showEditLoading = true;
    this.logSrv.updateActivityLog(this.editActivityForm.getRawValue())
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: any) => {
        this.showEditLoading = false;
        $("#closeLogModal").click();
        this.generalSrv.sweetAlertFileUpdateSuccessWithoutNav('Activity');
        this.feeds.getPageContext();
      }, (error) => {
        this.showEditLoading = false;
        $("#closeLogModal").click();
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      })
  }

  /**
   * Fetch Activity Type
   */
  private fetchLogActivityTypes() {
    this.logSrv.getActivityTypes().pipe(takeUntil(this.unsubscribe)).subscribe(activityType => {
      this.activityType = activityType;
    })
  }


  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
